import Component from './display-input';
export default Component;
